import { BaseEdge, EdgeLabelRenderer, getBezierPath } from "@xyflow/react"
import DebouncedCountChip from "./DebouncedCountChip.jsx"

// Render order + short label + tone for the chip strip. Hides zero counts
// so an idle edge stays blank. `running` is debounced via DebouncedCountChip
// so transient sub-second runs (idempotent short-circuits) don't flicker.
const COUNT_ROWS = [
  { key: "failed",    label: "failed", tone: "text-red-500 dark:text-red-400" },
  { key: "awaiting",  label: "wait",   tone: "text-amber-500 dark:text-amber-400" },
  { key: "running",   label: "run",    tone: "text-blue-500 dark:text-blue-400" },
  { key: "pending",   label: "queue",  tone: "text-muted-foreground" },
  { key: "skipped",   label: "skip",   tone: "text-slate-400 dark:text-slate-500" },
  { key: "succeeded", label: "done",   tone: "text-emerald-500 dark:text-emerald-400" }
]

export default function EdgeWithCounts({
  id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition,
  style, markerEnd, data, label
}) {
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX, sourceY, sourcePosition, targetX, targetY, targetPosition
  })

  const counts = data?.counts ?? {}
  const rows = COUNT_ROWS.filter(({ key }) => (counts[key] ?? 0) > 0)

  return (
    <>
      <BaseEdge id={id} path={edgePath} style={style} markerEnd={markerEnd} />
      <EdgeLabelRenderer>
        {(rows.length > 0 || label) && (
          <div
            data-edge-id={data?.edgeId}
            style={{
              position: "absolute",
              transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
              pointerEvents: "all"
            }}
            className="bg-card border border-border/60 rounded-full px-2 py-0.5 shadow-sm text-[10px] font-mono flex items-center gap-2 nodrag nopan empty:hidden"
          >
            {label && (
              <span className="uppercase tracking-wider opacity-70">{label}</span>
            )}
            {rows.map(({ key, label: rowLabel, tone }) => (
              key === "running"
                ? <DebouncedCountChip key={key} count={counts[key]} label={rowLabel} tone={tone} />
                : (
                  <span key={key} className={tone}>
                    <span className="font-semibold">{counts[key]}</span>{" "}
                    <span className="uppercase tracking-wider opacity-80">{rowLabel}</span>
                  </span>
                )
            ))}
          </div>
        )}
      </EdgeLabelRenderer>
    </>
  )
}
